<template>
  <v-main class="pa-4" fluid>
	  <v-row>

			<v-snackbar v-model="snackbar" :timeout="8000" top :color="color" >  {{text}}
        <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
      </v-snackbar>

	  	<v-col cols="12">
        <v-card  class="shadowCard" >
          <v-card-title primary-title>
            <span class="text-h5 font-weight-bold"> Cupones </span>
            <v-spacer></v-spacer>
						<v-btn color="primary" dark class="mr-2"  @click="nuevoCupon = true"> Nuevo </v-btn>
            <v-btn color="secondary" dark class="mr-2" @click="initialize()">  Actualizar </v-btn>
            <!-- <v-btn color="primary"   dark class="ma-2" @click="exportar()"> <v-icon>save_alt</v-icon> </v-btn> -->
          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-spacer></v-spacer>
                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    name="name"
                    label="Buscar"
                    id="id"
                    dense
                    hide-details
                    append-icon="mdi-magnify" 
                    v-model="search"
                    clearable
                  ></v-text-field>
                </v-col>
            </v-row>
						
						<v-row>
							<v-col>
								<v-data-table
									:headers="headers"
									:items="cupones"
									class="elevation-0"
                  :search="search"
                  :height="tamanioPantalla"
                  fixed-header
                  hide-default-footer
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  dense
								>
									<template v-slot:item.tipo="{ item }">
										<div v-if="item.tipo == 1">Fijo</div>
										<div v-else>Porcentaje</div>
										<div></div>
									</template>

									<template v-slot:item.estatus="{ item }">
										<div v-if="item.estatus == 1">Activo</div>
										<div v-else>Inactivo</div>
										<div></div>
									</template>

				
									<template v-slot:item.actions="{ item }">
										<v-btn fab small class="my-1" color="success" @click="editItem(item)">
											<v-icon> mdi-eye</v-icon>
										</v-btn>
										
										<!-- <v-icon
											small
											@click="deleteItem(item)"
										>
											mdi-delete
										</v-icon> -->
									</template>
								
								</v-data-table>
							</v-col>
						</v-row>


					</v-card-text>
					<v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
				</v-card>
	  	</v-col>


			<v-dialog v-model="nuevoCupon" max-width="800">
				<v-card class="pa-4">
					<!-- <v-card-title> <span class="text-h5">{{ formTitle }}</span>	</v-card-title> -->
					<v-toolbar flat class="">
						<div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> {{ formTitle }}  </div>
						<v-spacer></v-spacer>
						<v-btn color="error" fab small elevation="1" @click="close()" ><v-icon>clear</v-icon></v-btn>
					</v-toolbar>
					
					<v-card-text>
						<v-container>
							<v-row>
								<v-col cols="12">
									<v-text-field
										v-model="editedItem.cupon"
										label="Nombre"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" lg="3">
									<v-text-field
										v-model="editedItem.fecha1"
										label="Fecha inicio"
										type="date"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" lg="3">
									<v-text-field
										v-model="editedItem.fecha2"
										label="Fecha final"
										type="date"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" lg="2">
									<v-text-field
										v-model="editedItem.cantidad"
										label="Cantidad"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" lg="2">
									<v-text-field
										v-model="editedItem.canjeados"
										label="Canjeados"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" lg="4">
									<v-text-field
										v-model="editedItem.descuento"
										label="Descuento"
									></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" lg="4">
									Tipo de descuento
									<v-radio-group
										v-model="editedItem.tipo"
										row
									>
										<v-radio
											label="Fijo"
											:value="1"
										></v-radio>
										<v-radio
											label="Porcentaje"
											:value="2"
										></v-radio>
									</v-radio-group>
								</v-col>

								<v-col
									cols="12"
									sm="6"
									md="4"
								>
									<v-switch label="Activo" v-model="editedItem.estatus"></v-switch>
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>

					<div class="mt-6"></div>

					<v-footer absolute>
						<v-spacer></v-spacer>
						<v-btn color="primary" @click="save()"	dark>	Guardar	</v-btn>
					</v-footer>
				</v-card>
			</v-dialog>




	  </v-row>
	</v-main>
</template>

<script>
  import  metodos from '@/mixins/metodos.js';

  export default {
		mixins:[metodos],

    data: () => ({
    	text:'',
      snackbar:false,
      color:'',

      nuevoCupon: false,
      dialogDelete: false,
      headers: [
        { text: 'idcupones'   , align: 'start', sortable: false, value: 'idcupones', },
        { text: 'Cupon'       , value: 'cupon' },
        { text: 'Fecha inicio', value: 'fecha1' },
        { text: 'Fecha fin'   , value: 'fecha2' },
        { text: 'Cantidad'    , value: 'cantidad' },
        { text: 'Canjeados'   , value: 'canjeados' },
        { text: 'Descuento'   , value: 'descuento' },
        { text: 'tipo'        , value: 'tipo' },
        { text: 'Estatus'        , value: 'estatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      cupones: [],
      editedIndex: -1,
      editedItem: {
      	idcupones:0,
        cupon:'', 
        fecha1:'',
        fecha2:'',
        cantidad:'',
        canjeados:'',
        descuento:'',
        tipo:1,
        estatus:1
      },
      defaultItem: {
        idcupones:0,
        cupon:'', 
        fecha1:'',
        fecha2:'',
        cantidad:'',
        canjeados:'',
        descuento:'',
        tipo:1,
        estatus:1
      },
			search: '',

			page: 1,
      pageCount: 0,
      itemsPerPage: 40,
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Cupon' : 'Editar Cupon'
      },
    },

    watch: {
      nuevoCupon (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.cupones = []
        this.$http.get('cupones.all').then(response=>{
        	this.cupones = response.body
        }).catch(error=>{
        	console.log(error)
        })
      },

      editItem (item) {
        this.editedIndex = this.cupones.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.nuevoCupon = true
      },

      close () {
        this.nuevoCupon = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          this.$http.put('cupones.update/' + this.editedItem.idcupones, this.editedItem).then(response=>{
	        	this.initialize()
	        }).catch(error=>{
	        	console.log(error)
	        })
        } else {
          this.$http.post('cupones.add', this.editedItem).then(response=>{
	        	this.initialize()
	        }).catch(error=>{
	        	console.log(error)
	        })
        }
        this.close()
      },
    },
  }
</script>